export default __webpack_public_path__ + "static/media/facebook.e764da59.png";